<template>

      <div v-if="isModalVisible" class="modal-overlay">
        <div class="modal">
          <h3 class="modal-title">Ошибка регистрации</h3>
          <p class="modal-message">{{ errorMessage }}</p>
          <button class="modal-button" @click="isModalVisible = false">Закрыть</button>
        </div>
      </div>

    <div class="login-container">

      <DefaultHeader      
        title="Регистрация нового пользователя"
        subtitle="Регистрация нового пользователя через email"
        class="register-header"/>


      <div class="login-header">
        <img class="login-logo" />
      </div>
  
      <div class="register-wrapper">
        <div class="register_form" v-if="!isRegistered">
          <RegisterForm @register="handleRegistration" />
        </div>
  
        <div class="success-message" v-else>
          <h3 class="success-title">Регистрация успешна!</h3>
          <p class="success-text">
            Мы отправили письмо с подтверждением на ваш email.
            <br />Откройте почту и следуйте инструкциям, чтобы активировать аккаунт.
          </p>
        </div>
      </div>
  
      <Footer />

      <ElegantErrorDialog
        :visible="isModalVisible"
        title="Ошибка регистрации"
        :message="errorMessage"
        type="error"
        :autoCloseMs="3500"
        @close="isModalVisible = false"
      />
  
      <teleport to="body">
        <transition name="fade">
          <div v-if="isLoading" class="overlay">
            <div class="spinner"></div>
          </div>
        </transition>
      </teleport>

    </div>
  </template>
  
  <script setup>

  import { ref } from "vue";
  import { useRouter } from "vue-router";

  import DefaultHeader from "../components/RegisterHeader.vue";
  import RegisterForm from "../components/login/RegisterForm.vue";
  import RegistrationService from "../api/RegistrationService.js";
  import Footer from "../components/MiniFooter.vue";
  import ElegantErrorDialog from "../components/errors/ElegantErrorDialog.vue";

  const router = useRouter();
  const isLoading = ref(false);
  const isModalVisible = ref(false);
  const errorMessage = ref("");
  const isRegistered = ref(false);
  

const handleRegistration = async ({ email, password }) => {
  try {
    isLoading.value = true;
    localStorage.setItem("emailForSignIn", email);
    localStorage.setItem("user_password", password);

    const response = await RegistrationService.registerUser(email, password);

    if (response.success) {
      router.push("/email-verification");
    } else {
      errorMessage.value = response.error;
      isModalVisible.value = true;
    }
  } catch (error) {
    if (error.response) {
      errorMessage.value =
        error.response.data?.error || "Ошибка регистрации (сервер)";
    } else {
      errorMessage.value = "Нет подключения к серверу. Попробуйте позже.";
    }
    isModalVisible.value = true;
  } finally {
    isLoading.value = false;
  }
};

const goBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push("/");
  }
};

  </script>
  
  <style scoped>

.login-container {
  position: relative;
  width: 100%;
  height: 100dvh;
  min-height: 100dvh;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: var(--bg);
}
  
.login-header {
  position: absolute;
  inset: 0;
  z-index: 0;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  justify-content: center;
  align-items: flex-start;

  padding-top: 20px;
}

.login-header::after {
  content: "";
  position: absolute;
  inset: 0;

  background: linear-gradient(
    to bottom,
    rgba(0,0,0,.05),
    rgba(0,0,0,.18)
  );

  pointer-events: none;
}
  
  [data-theme="dark"] .login-header {
    background-image: url("../assets/login_header_dark.webp");
  }
  
  [data-theme="light"] .login-header {
    background-image: url("../assets/login_header_light.webp");
  }
  
  .login-logo {
  position: relative;
  z-index: 1;

  width: 180px;
  height: auto;

  transform: translateY(60px);

  content: url("../assets/login_logo_dark.png");
}
  
  [data-theme="light"] .login-logo {
    content: url("../assets/login_logo_light.png");
  }
  
  .register-wrapper {
  position: relative;
  z-index: 2;

  flex: 1;
  width: 100%;

  display: flex;
  justify-content: center;


  padding-top: 140px;
  padding-bottom: 24px;

  box-sizing: border-box;
}
  
footer {
  position: relative;
  z-index: 10;

  width: 100%;

  background: var(--bg);
  backdrop-filter: blur(20px);

  border-top: 1px solid rgba(255,255,255,.08);
}
  
  .modal-overlay {
  position: fixed;
  inset: 0; 
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #fff;
  color: #000;
  padding: 24px 32px;
  border-radius: 12px;
  max-width: 320px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  text-align: center;
  font-family: "Eastman-Regular", sans-serif;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.modal-message {
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.4;
}

.modal-button {
  background-color: #2173E5;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-family: "Eastman-Bold", sans-serif;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.modal-button:hover {
  opacity: 0.9;
}
  /* Убираем только горизонтальный скролл */
  html, body {
    overflow-x: hidden;
  }

  .overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483647; /* поверх любого футера */
  pointer-events: all;
}

/* спинер можно оставить как есть */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255,255,255,0.25);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

@media (max-width:768px) {

.login-header {
  background-position: center top;
  padding-top: calc(18px + env(safe-area-inset-top));
}

.login-logo {
  width: 140px;
  transform: translateY(-12px);
}

.register-wrapper {
  padding: 70px 16px 18px;
}
}

@media (max-width:430px) {

.login-logo {
  width: 126px;
}

.register-wrapper {
  padding-top: 54px;
  padding-bottom: 12px;
}

footer {
  display: none;
}
}


.back-button {
  position: absolute;
  top: 22px;
  left: 22px;
  z-index: 20;

  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 50%;

  color: rgba(255, 255, 255, 0.92);

  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.14),
      rgba(255, 255, 255, 0.07)
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.16),
    0 8px 24px rgba(0, 0, 0, 0.14);

  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  cursor: pointer;

  transition:
    transform 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.back-button:hover {
  transform: translateY(-1px);

  border-color: rgba(255, 255, 255, 0.24);

  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.1)
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 12px 30px rgba(0, 0, 0, 0.18);
}

.back-button:active {
  transform: scale(0.94);
}

.back-button:focus-visible {
  outline: 2px solid rgba(40, 135, 247, 0.7);
  outline-offset: 3px;
}

[data-theme="light"] .back-button {
  color: rgba(17, 17, 17, 0.86);

  border-color: rgba(17, 17, 17, 0.08);

  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.82),
      rgba(255, 255, 255, 0.56)
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.9),
    0 8px 24px rgba(0, 0, 0, 0.08);
}

[data-theme="light"] .back-button:hover {
  border-color: rgba(17, 17, 17, 0.14);

  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.96),
      rgba(255, 255, 255, 0.72)
    );
}

@media (max-width: 768px) {
  .back-button {
    top: calc(18px + env(safe-area-inset-top));
    left: 16px;

    width: 40px;
    height: 40px;
  }
}

@media (max-width: 430px) {
  .back-button {
    top: calc(14px + env(safe-area-inset-top));
    left: 14px;

    width: 38px;
    height: 38px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .back-button {
    transition: none;
  }
}

.register-header {
  position: relative;
  z-index: 10;
  width: 100%;
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255,255,255,0.08);
}

  </style>